import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { of, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import {
    ECountriesActions,
    GetCountries, GetCountriesFailure, GetCountriesSuccess
} from '../actions/countries.actions';
import { HttpErrorResponse } from '@angular/common/http';
import { CountryService } from '../../services/country.service';
import { CountryInterface } from '../../models/country.interface';
import { AbstractEffects } from '../../abstract.effects';

@Injectable()
export class CountriesEffects extends AbstractEffects {

    constructor(
      private actions: Actions,
      private countryService:CountryService,
      public override store: Store<any>
    ) {
        super(store);
    }

    getCountries = createEffect(() => this.actions.pipe(
        ofType<GetCountries>(ECountriesActions.GetCountries),
        switchMap(() => this.countryService.get()),
        switchMap((response: Array<CountryInterface>) => of(new GetCountriesSuccess(response))),
        catchError((error: HttpErrorResponse) => {
            if (401 === error.status || 403 === error.status) {
                this.ResendRequestWithNewToken(new GetCountries());
            } else {
                this.DisplayMessage('error_with_retry', 400, new GetCountriesFailure());
            }
            return throwError(error);
        })
    ));
}
